import * as SessionStorageWrapper from "../../utils/SessionStorageWrapper";

// Router state { from: "shipping" } is lost on reload and on return from a payment provider;
// this per-order session flag survives both, so Back still returns to Shipping.
const flagKey = (hashID: string) => `payment_from_shipping:${hashID}`;

const isFromShippingState = (routerState: unknown) => (routerState as { from?: string } | null)?.from === "shipping";

export const markPaymentFromShipping = (hashID: string) => SessionStorageWrapper.setItem(flagKey(hashID), "1");

// Reloads and provider returns arrive as POP and keep the flag. An in-app arrival without Shipping's
// state (My Account "Pay Now") starts a new visit, so an older flag must not send Back to Shipping.
export const resetPaymentOriginOnArrival = (hashID: string | undefined, routerState: unknown, navigationType: string) => {
  if (hashID && navigationType !== "POP" && !isFromShippingState(routerState)) {
    SessionStorageWrapper.removeItem(flagKey(hashID));
  }
};

export const cameToPaymentFromShipping = (hashID: string | undefined, routerState: unknown): boolean =>
  isFromShippingState(routerState) || (!!hashID && SessionStorageWrapper.getItem(flagKey(hashID)) === "1");
